import libParse, { isPossibleNumber } from 'libphonenumber-js';
import { coerce, define, string } from 'superstruct';

/**
 * Checks if number has correct digits and is in the format of +1234567890
 */
const dbPhoneNumber = () => define('phone number', value => {
  if (typeof value !== 'string' || value === '') {
    return true; // Allow empty values (optional field)
  }

  // Check if value starts with + (has country code)
  if (!value.startsWith('+')) {
    return {
      message: 'validations:Phone number must include country code (e.g., +1)'
    };
  }

  // Check if it's a valid international number
  if (isPossibleNumber(value) && /\+\d+?/gmu.test(value)) {
    return true;
  } else {
    return {
      message: 'validations:Invalid PhoneNumber'
    };
  }
});

/**
 * Ensure that a value is a phone number in E.123 international notation without grouping.
 */
export const phoneNumber = () => coerce(dbPhoneNumber(), string(), parsePhoneNumber);

/**
 * Wrapper around parsePhoneNumber from libphonenumber-js that does not
 * show errors in console on bad input
 * @param value Potential phone number value
 */
export function parsePhoneNumber(value) {
  if (value === '' || value === undefined) {
    return value;
  }
  let parsed;
  if (isPossibleNumber(value, 'US')) {
    parsed = libParse(value, 'US')?.number;
  }
  if (!parsed && isPossibleNumber(value)) {
    parsed = libParse(value)?.number;
  }
  return parsed ?? value;
}